
/* injects from baggage-loader */

'use strict';



function routeConfig($urlRouterProvider) {
	'ngInject';



	$urlRouterProvider.otherwise('/');

}

export default angular
	.module('index.routes', [])
	.config(routeConfig);




// WEBPACK FOOTER //
// ./src/app/index.routes.js